/** Menu helpers for the Visitors Desk's full-screen shell. */
import { deskPubsOf, deskTabsOf, type DeskAccessMe } from './deskAccess'
import { DESK_PUBS, deskPath } from './deskTabs'
import { pubLabel } from './deskFormat'

/** One link per title the account may open, All titles first. Each keeps the current tab when the
 *  account has it, otherwise goes to the account's first tab. */
export function vdTitleLinks(me: DeskAccessMe, currentTab: string, search: string): { to: string; label: string; pub: string }[] {
  const tabs: string[] = deskTabsOf(me)
  const tab = tabs.includes(currentTab) ? currentTab : tabs[0] ?? currentTab
  const pubs = deskPubsOf(me)
  const ordered = [...DESK_PUBS].sort((a, b) => Number(b === 'all') - Number(a === 'all'))
  return ordered.filter((p) => pubs.includes(p)).map((pub) => ({ to: deskPath(pub, tab, search), label: pubLabel(pub), pub }))
}

/** Admins always; editors and writers when they have at least one desk tab. */
export function vdMayUse(me: DeskAccessMe | undefined): boolean {
  if (!me) return false
  if (me.role === 'admin') return true
  return (me.role === 'editor' || me.role === 'writer') && deskTabsOf(me).length > 0
}

export function vdShowsSettings(role: string | undefined): boolean {
  return role === 'admin'
}
